// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.GalleryRowWidget = ( function()
{
    "use strict";

    GalleryRowWidget.prototype = new CollectionRowWidget();

    function GalleryRowWidget(){}

    /**
     * @memberof GalleryRowWidget
     * @param params
     * @returns {GalleryRowWidget}
     * @see CollectionRowWidget
     */
    GalleryRowWidget.prototype.init = function( params )
    {
        params.type = GalleryCellWidget;
        params.y    = _x2.scaleVal( 160 ) - _x2.scaleVal( 12 );
        params.h    = _x2.scaleValInt( 530 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "GalleryRowWidget";

        return this;
    };

    GalleryRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 690 );
    };

    return GalleryRowWidget;

})();
